<template lang="html">
    <div class="layout-div__container">
        <div class="layout-div__title">
            <span class="layout-span__title__text">
                <i class="layout-i__line"><!-- 竖线 --></i>综合得分
            </span>
        </div>
        <div class="layout-div__body">
            <canvas id="score" width="456" height="456" class="sr-canvas__score"></canvas>
            <ul class="sr-ul__result__group">
                <li class="sr-li__result__item"><i class="layout-i__circle"></i>你的肌龄约为 <i class="layout-i__font big-font">{{score.skinAge}}</i>， </li>
                <li style="margin-left: 0.5rem;">综合得分超过了全国 <i class="layout-i__font big-font">{{parseInt(score.transcendPercent * 100)}}%</i>的{{score.gender}}。</li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Progress from '@/lib/progressbar'
export default {
  beforeMount () {
    let {total_score, skin_age, transcend_percent, gender} = this.$store.state.result.resultData
    this.score = Object.assign({}, {
      totalScore: total_score,
      skinAge: skin_age,
      transcendPercent: transcend_percent,
      gender: gender === 'female' ? '女生' : '男生'
    })
  },
  mounted () {
    this.canvas = document.getElementById('score')
    this.scoreLoading(this.score.totalScore)
  },
  methods: {
    scoreLoading (score) {
      let progressScore = new Progress('score', 'score', this.canvas.getContext('2d'), {
        percent: score,
        circleX: this.canvas.width / 2,
        circleY: this.canvas.height / 2,
        radius: 204,
        lineWidth: 24,
        process: 0
      })
      progressScore.scoreCircle()
      let circleLoading = setInterval(function () {
        progressScore.scoreLoading(circleLoading)
      }, 20)
    }
  },
  data () {
    return {
      score: {}
    }
  }
}
</script>

<style scoped>

.sr-canvas__score{
    width: 40.533333333vw;
    height: 40.533333333vw;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 4vw;
}

.sr-ul__result__group{
    margin:0;
    padding: 0;
    list-style: none;
    margin-top: 8vw;
}
.sr-ul__result__group{
    font-size: 4vw;
    font-family: 'PingFangSC'
}
.sr-li__result__item{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/score.vue